import { invenioConfig } from "@config/index";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { Button, List, Modal } from "semantic-ui-react";

export default class PatronBulkExtendLoans extends Component {
  state = { open: false };

  open = () => this.setState({ open: true });
  close = () => this.setState({ open: false });

  handleSubmitExtend = () => {
    const { bulkLoanExtension, patronPid } = this.props;

    bulkLoanExtension(patronPid);
    this.close();
  };

  render() {
    const { open } = this.state;
    const extensionDays = invenioConfig.CIRCULATION.extensionDurationDays;

    return (
      <Modal open={open} onClose={this.close}>
        <Modal.Header>Confirm extension action</Modal.Header>
        <Modal.Content>
          <Modal.Description>
            The loan duration will be extended by <b>{extensionDays} days</b>{" "}
            for:{" "}
            <List bulleted>
              <List.Item>
                loans that are <b>due today,</b>
              </List.Item>
              <List.Item>
                loans that do not involve third party libraries (Interlibrary
                Loans),
              </List.Item>
              <List.Item>
                loans for <b>literature not in high demand by other users.</b>
              </List.Item>
              <List.Item>
                loans that have not reached the maximum number of extensions (
                <b>{invenioConfig.CIRCULATION.extensionsMaxCount}</b>).
              </List.Item>
            </List>
            Do you want to continue?
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={this.close}>Cancel</Button>
          <Button onClick={this.handleSubmitExtend} primary>
            Extend the loans
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

PatronBulkExtendLoans.propTypes = {
  patronPid: PropTypes.string.isRequired,
  bulkLoanExtension: PropTypes.func.isRequired,
};

PatronBulkExtendLoans.defaultProps = {};
